import lang from '../../lib/language';
import { FeatureFlags } from '../../lib/util/flags/types';

import dashboardIcon from '../../assets/img/icon-dashboard.svg';
import dashboardIconActive from '../../assets/img/icon-dashboard-active.svg';
import discoverIcon from '../../assets/img/icon-discover.svg';
import discoverIconActive from '../../assets/img/icon-discover-active.svg';
import helpLogo from '../../assets/img/icon-help_24px.svg';
import payoutIcon from '../../assets/img/icon-payout.svg';
import payoutIconActive from '../../assets/img/icon-payout-active.svg';
import referralsIcon from '../../assets/img/icon-referrals.svg';
import referralsIconActive from '../../assets/img/icon-referrals-active.svg';
import tradeHistoryIcon from '../../assets/img/icon-tradeHistory.svg';
import tradeHistoryIconActive from '../../assets/img/icon-tradeHistory-active.svg';
import watchlistIcon from '../../assets/img/icon-watchlist.svg';
import watchlistIconActive from '../../assets/img/icon-watchlist-active.svg';
import { UI_ROUTES } from '../../util/routes';

import { SideBarItem } from './Sidebar.types';

export const MENU_LIST: SideBarItem[] = [
  {
    id: 'dashboardMenuItem',
    label: lang.commonDashboard(),
    path: UI_ROUTES.dashboard,
    img: <img src={dashboardIcon} alt="icon my account" />,
    activeImg: <img src={dashboardIconActive} alt="icon my account" />,
  },
  {
    id: 'watchlistMenuItem',
    label: lang.commonWatchlist(),
    path: UI_ROUTES.overview,
    img: <img src={watchlistIcon} alt="icon watchlist" />,
    activeImg: <img src={watchlistIconActive} alt="icon watchlist" />,
  },
  {
    id: 'discoverMenuItem',
    label: lang.commonDiscoverTitle(),
    path: UI_ROUTES.discover,
    img: <img src={discoverIcon} alt="icon discover" />,
    activeImg: <img src={discoverIconActive} alt="icon discover" />,
  },
  {
    id: 'payoutsMenuItem',
    label: lang.commonPayoutsTitle(),
    path: UI_ROUTES.payouts,
    img: <img src={payoutIcon} alt="payouts" />,
    activeImg: <img src={payoutIconActive} alt="payouts" />,
    hiddenByFeatureFlag: FeatureFlags.referrals,
  },
  {
    id: 'referralsMenuItem',
    label: lang.referralsTitle(),
    path: UI_ROUTES.referrals,
    img: <img src={referralsIcon} alt="icon referrals" />,
    activeImg: <img src={referralsIconActive} alt="icon referrals" />,
    featureFlag: FeatureFlags.referrals,
  },
  {
    id: 'historyMenuItem',
    label: lang.commonTitleHistory(),
    path: UI_ROUTES.tradeHistory,
    img: <img src={tradeHistoryIcon} alt="icon up and down arrows" />,
    activeImg: <img src={tradeHistoryIconActive} alt="icon up and down arrows" />,
  },
];

/** Every flag the menu depends on, so `useFlags` stays in step with MENU_LIST. */
export const MENU_FEATURE_FLAGS: FeatureFlags[] = [
  ...new Set(
    MENU_LIST
      .flatMap(item => [ item.featureFlag, item.hiddenByFeatureFlag ])
      .filter((flag): flag is FeatureFlags => !!flag),
  ),
];

export const SUPPORT_LIST: SideBarItem[] = [
  {
    id: 'helpCenterMenuItem',
    label: lang.myProfileHelpCenter(),
    path: '',
    img: <img src={helpLogo} alt="icon help Logo" />,
    activeImg: <img src={helpLogo} alt="icon help Logo" />,
  },
];
